import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable, filter, take, map } from 'rxjs'
import { employeeAPIModel } from 'src/app/models/api.model'
import { WebService } from 'src/app/services/api/web.service'
import { EmployeeService } from 'src/app/services/employee/employee.service'
import { getUserFromState } from 'src/app/store/selector/initialize.selector'
import {
  CommonInsertEmployeeValidator,
  InsertEmployeeValidator,
  IntelInsertEmployeeValidator
} from './insert-employee.validator'

@Injectable({ providedIn: 'root' })
export class EmployeeValidatorFactory {
  constructor(
    private readonly store: Store,
    private readonly empService: EmployeeService,
    private readonly web: WebService
  ) {}

  create(u: employeeAPIModel, sendMail: boolean): Observable<CommonInsertEmployeeValidator> {
    return this.store.select(getUserFromState).pipe(
      filter(Boolean),
      take(1),
      map(user => {
        // RMS ADMIN → Normal Insert
        if (user.userType === 'RMS_ADMIN') {
          return new InsertEmployeeValidator(this.empService, u, this.web, sendMail)
        }

        // INTEL → Intel Insert
        if (user.companyGroupCode === 'INTEL') {
          return new IntelInsertEmployeeValidator(this.empService, u, this.web, sendMail)
        }

        // Default fallback
        return new InsertEmployeeValidator(this.empService, u, this.web, sendMail)
      })
    )
  }
}
